const laptopDetailedRateCard = {
  key: "laptop",
  title: "Laptop Basic Support Detailed Rate Card",
  note:
    "Indicative laptop support pricing. Board-level faults, screen replacement, and advanced hardware repair should be diagnosed before exact quote.",
  sections: [
    {
      title: "Diagnosis",
      items: [
        { name: "Laptop diagnosis", price: "₹299 visit" },
      ],
    },
    {
      title: "Software Support",
      items: [
        { name: "Basic software support", price: "₹499 onwards" },
        { name: "OS installation / reset", price: "₹699 onwards" },
      ],
    },
    {
      title: "Maintenance",
      items: [
        { name: "Basic laptop cleaning / check", price: "₹499 onwards" },
      ],
    },
  ],
};

export default laptopDetailedRateCard;